import { render, staticRenderFns } from "./SignEventManage.vue?vue&type=template&id=5bc73996&scoped=true&"
import script from "./SignEventManage.vue?vue&type=script&lang=js&"
export * from "./SignEventManage.vue?vue&type=script&lang=js&"
import style0 from "./SignEventManage.vue?vue&type=style&index=0&id=5bc73996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc73996",
  null
  
)

export default component.exports